export {};
// import CodeIDEScreen from '../screens/CodeIDEScreen/CodeIDEScreen'
// import CourseAssignmentScreen from '../screens/CourseAssignmentScreen/CourseAssignmentScreen'
// import CourseVideosScreen from '../screens/CourseVideosScreen/CourseVideosScreen'
// import GymScreen from '../screens/GymScreen/GymScreen'
// import ContestsScreen from '../screens/ContestsScreen/ContestsScreen'
// import ContestFullScreen from '../screens/ContestFullScreen/ContestFullScreen'
// import CourseAssignmentsScreen from '../screens/CourseAssignmentsScreen/CourseAssignmentsScreen'
// import FullCourseHomeScreen from '../screens/FullCourseHomeScreen/FullCourseHomeScreen'
// import CourseVideoScreen from '../screens/CourseVideoScreen/CourseVideoScreen'
// import ProfileScreen from '../screens/ProfileScreen/ProfileScreen'
// import FileExplorer from '../screens/Notes/FileExplorer'
// import SoftSkillsScreen from '../screens/SoftSkillsScreen/SoftSkillsScreen'
// import InterviewQuestionsScreen from '../screens/SoftSkillsScreen/InterviewQuestionsScreen'
// import VideoClass from '../screens/VideoClassScreen/VideoClass'
// import SessionsScreen from '../screens/SessionsScreen/SessionsScreen'
// import ProfileDetails from '../screens/ProfileDetails/ProfileDetails'
// import ContestCodeIDEScreen from '../screens/CourseCodeIDEScreen/ContestCodeIDEScreen'
// import NotesDashboard from '../screens/Notes/NotesDashboard.js'
// import ReferralsScreen from '../screens/ReferralsScreen/ReferralsScreen'
// import { RoleEnum } from './roles.enum'
// import SessionFeedback from '../screens/SessionFeedbackScreen/SessionFeedback'
// import HomeScreen from '../screens/HomeScreen/HomeScreen'
// import {useSelector} from "react-redux";
//
// // const homescreenState = useSelector((state:any)=> state.homescreen)
// // const {selectedCourse} = homescreenState
//
// export default {
//   [RoleEnum.Mentor]: {
//     routes: [
//       {
//         url: '/session-feedback',
//         component: SessionFeedback,
//       },
//     ],
//   },
//   [RoleEnum.Instructor]: {},
//   [RoleEnum.Admin]: {},
//   [RoleEnum.PrecourseUser]: {},
//   [RoleEnum.MainCourseUser]: {
//     routes: [
//       {
//         url: '/course/codeIde/:id/:type?',
//         component: CodeIDEScreen
//       },
//       {
//         url: '/home',
//         component: HomeScreen
//       },
//       {
//         url: '/me',
//         component: ProfileScreen
//       },
//       {
//         url: '/soft-skills/interview-questions',
//         component: InterviewQuestionsScreen
//       },
//       {
//         url: '/course/class',
//         component: VideoClass
//       },
//       {
//         url: '/updateProfile',
//         component: ProfileDetails
//       },
//       {
//         url: '/course/contests/:contestId/codingQuestion/:id',
//         component: ContestCodeIDEScreen
//       },
//       {
//         url: '/admin/notesdashboard',
//         component: NotesDashboard
//       },
//       {
//         url: '/referrals',
//         component: ReferralsScreen
//       },
//     ],
//   },
// }
